import { AccessoriesFrontPannelIcon } from "@jti/brand-icons/accessories-front-pannel";
import { DeviceDefaultIcon } from "@jti/brand-icons/device-default";
import { DiamondIcon } from "@jti/brand-icons/diamond";
import { StickIcon } from "@jti/brand-icons/stick";

import { createDisplayResolver } from "./createDisplayResolver";

export const PRODUCT_CONFIG = {
  STICK: {
    icon: <StickIcon />,
    i18nKey: "store_locator.products.stick",
  },
  PLOOM_DEVICE: {
    icon: <DeviceDefaultIcon />,
    i18nKey: "store_locator.products.ploom_device",
  },
  ACCESSORIES: {
    icon: <AccessoriesFrontPannelIcon />,
    i18nKey: "store_locator.products.accessories",
  },
  LIMITED_EDITION: {
    icon: <DiamondIcon />,
    i18nKey: "store_locator.products.limited_edition",
  },
} as const;

const LEGACY_PRODUCT_MAP = {
  stick: "STICK",
  ploomdevice: "PLOOM_DEVICE",
  accessories: "ACCESSORIES",
  limitededition: "LIMITED_EDITION",
} as const;

const productResolver = createDisplayResolver(PRODUCT_CONFIG, LEGACY_PRODUCT_MAP);

export type ProductId = keyof typeof PRODUCT_CONFIG;
export const normalizeProductKey = productResolver.normalizeKey;
export const resolveProductId = productResolver.resolveId;
export const getProductDisplay = productResolver.getDisplay;
